export default __webpack_public_path__ + "static/media/icon-direction-gauche.075925fc.svg";